import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'asistente-ia/chat';

/**
 * POST Chat Asistente IA
 * @param {object} values - { mensaje, empleado_id? }
 * @returns {Promise<object|boolean>}
 */
export const postChatAsistenteIA = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export default postChatAsistenteIA;
